import { type SVGProps } from 'react';

import { withDynamicStroke } from '../../withDynamicStroke';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m21 17.979-8.188 3.639a2 2 0 0 1-1.624 0L3 17.978m18-5-8.188 3.64a2 2 0 0 1-1.624 0L3 12.978m.789-5.105 7.317 3.659a2 2 0 0 0 1.788 0l7.317-3.659a1 1 0 0 0 0-1.789l-7.317-3.658a2 2 0 0 0-1.788 0L3.789 6.084a1 1 0 0 0 0 1.79"
    />
  </svg>
);
export const IconLayers = withDynamicStroke(Icon);
